<template>
  <b-modal
    :hide-footer="true"
    centered
    :no-close-on-backdrop="true"
    size="xl"
    id="modal-busca-familia"
    :title="title"
  >
    <template #modal-header="{ close }">
      <h5 v-html="title"></h5>
      <button
        type="button"
        aria-label="Close"
        class="close text-danger"
        @click="close()"
      >
        ×
      </button>
    </template>
    <form @submit.prevent="submitSearch" ref="search">
      <b-input-group class="mt-0">
        <b-input-group-prepend>
          <b-input-group-text>
            <b-icon icon="search"></b-icon>
          </b-input-group-text>
        </b-input-group-prepend>
        <b-form-input
          v-model="search"
          placeholder="Digite um Nome de Usuário, Responsável Familiar, Filiação 1 ou CPF e tecle enter"
          @keyup.enter="submitSearch"
        ></b-form-input>
        <b-input-group-append v-if="showResultSearch">
          <b-button
            @click="
              showResultSearch = false;
              search = null;
            "
            variant="danger"
            type="submit"
            data-style="zoom-in"
            class="btn-submit"
            >Limpar Busca</b-button
          >
        </b-input-group-append>
      </b-input-group>
    </form>

    <ResultSearchFamilia
      :search="search"
      :loading="loadingFamilia"
      :familias-list="familiasList"
      v-if="showResultSearch"
      :pagination="pagination"
      @fechar="showResultSearch = false"
      @load="getFamilias"
      @close="$bvModal.hide('modal-busca-familia')"
    />
  </b-modal>
</template>
<script>
import ResultSearchFamilia from "./ResultSearchFamilia";
export default {
  components: { ResultSearchFamilia },
  props: [],
  data() {
    return {
      showResultSearch: false,
      familiasList: [],
      search: "",
      page: 1,
      perPage: 4,
      title: "Buscar por Familia/Usuário",
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
    };
  },
  mounted() {},
  methods: {
    submitSearch: function submitSearch() {
      this.showResultSearch = false;
      if (this.search != "" && this.search.length > 3) {
        //clearTimeout(submitSearch.timeout);
        this.getFamilias();
        this.$root.$emit("submitsearch", this.search);
      }
    },
    getFamilias(page = 1, perPage = 10) {
      this.showResultSearch = true;
      this.loadingFamilia = true;
      axios
        .get("api/dashboard/buscar/usuarios", {
          params: {
            page: page,
            lupa: this.search,
            perPage: perPage,
            // filtroFamiliares: this.filtroFamiliares
          },
        })
        .then((response) => {
          this.familiasList = response.data.data;
          this.pagination = response.data.pagination;
          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getFamilias(page);
          } else {
            this.loadingFamilia = false;
          }
        })
        .catch(() => {
          this.loadingFamilia = false;
        });
    },
  },
};
</script>
